export default __webpack_public_path__ + "static/media/zoomOut.f902d4b0.svg";